import { Inversify } from '@/src/shared/utils/Inversify';

import EntityResolverHttpClient_Factory from '../../../src/cms/data/services/entity-resolver-http-client.factory';
import EntityResolver_Factory from '../../../src/cms/data/services/entity-resolver.factory';
import ClientEnvVars from '../../../src/shared/domain/models/client-env-vars';
import ServerEnvVars from '../../../src/shared/domain/models/server-env-vars';

const useTestingMocking = process.env.MODE === 'testing';

if (useTestingMocking) console.warn('⚠️ Using testing mocking');

export const INVERSIFY_CONFIG = {
  EntityResolverHttpClient_Factory: { newable: EntityResolverHttpClient_Factory },
  EntityResolver_Factory: { newable: EntityResolver_Factory },
  ClientEnvVars: { newable: ClientEnvVars },
  ServerEnvVars: { newable: ServerEnvVars },
  GetBaseLayoutMenus_UseCase: {
    dynamicImport: () =>
      import('../../../src/cms/application/get-base-layout-menus.useCase')
  },
  GetCMSBlocks_UseCase: {
    dynamicImport: () =>
      import('../../../src/cms/application/get-cms-blocks.useCase')
  },
  GetCMSContentForPath_UseCase: {
    dynamicImport: () =>
      import('../../../src/cms/application/get-cms-content-for-path.useCase')
  },
  GetCMSMenu_UseCase: {
    dynamicImport: () =>
      import('../../../src/cms/application/get-cms-menu.useCase')
  },
  GetCMSSiteSettings_UseCase: {
    dynamicImport: () =>
      import('../../../src/cms/application/get-cms-site-settings.useCase')
  },
  SendContactFormUseCase: {
    dynamicImport: () =>
      import('../../../src/contact/application/send-contact-form.useCase')
  },
  FixtureCMSBlocks_Repository: {
    dynamicImport: () =>
      import('../../../src/cms/data/repositories/cms-blocks.repository')
  },
  ServerCMS_Repository: {
    dynamicImport: () =>
      import('../../../src/cms/data/repositories/server-cms.repository')
  },
  ServerCMS_Service: {
    dynamicImport: () =>
      import('../../../src/cms/data/services/server-cms.service')
  },
  CMSBlocksShowcasePage_Controller: {
    dynamicImport: () =>
      import('../../../src/cms/presentation/controllers/cms-blocks-showcase-page-controller')
  },
  Contact_Repository: {
    dynamicImport: () =>
      import('../../../src/contact/data/repositories/Contact.repository')
  },
  ThankYouPageController: {
    dynamicImport: () =>
      import('../../../src/contact/presentation/controllers/thank-you-page-controller')
  },
  RestService: {
    dynamicImport: () =>
      import('../../../src/shared/data/services/rest-service')
  },
  GetContactConfirmation_UseCase: {
    dynamicImport: () =>
      import('../../../src/contact/application/use-cases/get-contact-confirmation-use-case')
  }
} as const;

export const IOC = Inversify.create(INVERSIFY_CONFIG);
